/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface AuditExportRequest {
  range_start: string;
  range_end: string;
  /** @maxItems 200 */
  actions?: string[];
  /** @maxItems 200 */
  severities?: string[];
  /** @maxItems 200 */
  actor_ids?: string[];
  /**
     * @maxItems 200
     * @items.maxLength 320
     */
  actor_names?: string[];
  /** @maxItems 200 */
  targets?: string[];
  search?: string | null;
}
